import React from 'react';
import { cn } from '../../lib/utils';

interface PageContentContainerProps {
  children: React.ReactNode;
  className?: string;
}

function PageContentContainer({
  children,
  className
}: Readonly<PageContentContainerProps>): React.ReactElement {
  return (
    <div className={cn('space-y-6 min-w-0 max-w-full', className)}>
      {children}
    </div>
  );
}

export default PageContentContainer;
